export default __webpack_public_path__ + "static/media/D2022_05_26_Ostia_Palpita_2.f96be087.jpg";